import { RemovableSegment } from "@app/components/React/Common/RemovableSegment";
import { FieldArray, FormikProps, useFormikContext } from "formik";
import { ReactNode } from "react";
import { Button, Icon } from "@/components/bp/bp-ui";

export type RepeaterProps<TInstance extends any, T extends any, K extends keyof TInstance> = {
    name: K;
    instanceType: TInstance; // for intellisense only
    newItemFactory: () => T;
    onChange?: (item: T) => void;
    addButtonLabel: string;
    children: (props: { form: FormikProps<any>, remove: (index: number) => void, item: T, idx: number }) => ReactNode;
    disabled?: boolean;
    maxItems?: number;
    // children: any;
};

export function Repeater<TInstance extends any, T extends {}, K extends keyof TInstance>({ name, newItemFactory, addButtonLabel, children, disabled, maxItems, onChange: onChange }: RepeaterProps<TInstance, T, K>) {

    return (
        <FieldArray name={name as string}>
            {({ push, remove, form }) => {
                return (
                    <>
                        {form.values?.[name]?.map((item, idx) => (
                            <RemovableSegment disabled={disabled} key={idx} remove={() => {
                                remove(idx);
                                onChange?.(item);
                            } }>
                                {children({ form, remove, item: item, idx })}
                            </RemovableSegment>
                        ))}
                        {!disabled && (maxItems == undefined || form.values[name].length < maxItems) && <Button
                            icon
                            labelPosition="left"
                            color="green"
                            type="button"
                            onClick={() => {
                                const newItem = newItemFactory();
                                push(newItem);
                                onChange?.(newItem);
                            } }
                            disabled={disabled || (maxItems !== undefined && form.values[name].length >= maxItems)}>
                            <Icon name="plus" />
                            {addButtonLabel}
                        </Button>}
                    </>
                );
            }}
        </FieldArray>
    );
}

// export function useRepeater<TInstance extends any, T extends {}, K extends keyof TInstance>({ name, newItemFactory, addButtonLabel, children, disabled, maxItems, onChange, instanceType }: RepeaterProps<TInstance, T, K>) {
//     const formik = useFormikContext();

//     const push = (item: any) => {
//         formik.setFieldValue(name as string, [...formik.values[name] as any[], item]);
//         onChange?.(item);
//     };

//     const remove = (index: number) => {
//         const newItems = [...formik.values[name] as any[]];
//         newItems.splice(index, 1);
//         formik.setFieldValue(name as string, newItems);
//     };

//     const Renderer = () => (
//         <Repeater
//             name={name}
//             instanceType={instanceType}
//             newItemFactory={newItemFactory}
//             addButtonLabel={addButtonLabel}
//             disabled={disabled}
//             maxItems={maxItems}
//             onChange={onChange}>
//             {children}
//         </Repeater>
//     );

//     return {
//         push,
//         remove,
//         Renderer: Renderer
//     };
// }
